/* eslint-disable @typescript-eslint/no-explicit-any */
import {ShadowITEntity} from 'interfaces'
import {Dispatch, SetStateAction} from 'react'
import {formatBytes} from 'utils'
import {
  STREAM_GRAPH_SPACING_BOTTOM_PX,
  STREAM_GRAPH_SPACING_TOP_PX,
} from './applyStreamGraphMinHeight'

export const selectedAppView = 'SelectedAppView'
export const topActivityView = 'TopActivityView'
export const topApplicationsView = 'TopApplicationsView'
export const userSearchView = 'UserSearchView'
export const streamGraphColors = ['#D4A0FF', '#AF50FF', '#604CBF']
export const application = 'Application'
export const location = 'Location'
export const emptyString = ''
export const emptyArray = []
export const numZero = 0,
  numTwo = 2,
  numTen = 10,
  numTwenty = 20,
  numThirty = 30,
  numThirtyFour = 34,
  numFortyFive = 45
export const border = 'border',
  flex = 'flex',
  wFull = 'w-full',
  itemsCenter = 'items-center',
  justifyBetween = 'justify-between',
  justifyCenter = 'justify-center',
  textSm = 'text-sm',
  textWhite = 'text-white',
  ml2 = 'ml-2',
  relative = 'relative'
const blackColor = '#090909'
const whiteColor = '#FFF'
const emptyData = {y: numZero}
const defaultCategoryLabels = ['-', '-', '-', '-', '-', '-', '-']

export const emptyStreamGraphSeries = [
  {
    name: '',
    data: [
      emptyData,
      emptyData,
      emptyData,
      emptyData,
      emptyData,
      emptyData,
      emptyData,
    ],
  },
]

export const streamGraphRawOptions = (
  streamClickHandler?: any,
  setHoveredApp?: Dispatch<SetStateAction<ShadowITEntity | undefined>>,
  categoryLabels?: string[],
) => {
  return {
    chart: {
      type: 'streamgraph',
      zoomType: '',
      backgroundColor: blackColor,
      marginLeft: numTwo,
      marginRight: numTwo,
      spacingTop: STREAM_GRAPH_SPACING_TOP_PX,
      spacingBottom: STREAM_GRAPH_SPACING_BOTTOM_PX,
      events: {
        render: function () {
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          const chart: any = this
          const series = chart?.series || []
          series.forEach((seriesItem: any, index: number) => {
            seriesItem.group.element.id = `stream-series-${index}`
          })
        },
      },
    },
    credits: {
      enabled: false,
    },
    title: {
      floating: true,
      align: 'left',
      text: '',
    },
    subtitle: {
      floating: true,
      align: 'left',
      y: numThirty,
      text: '',
    },
    xAxis: {
      minPadding: numZero,
      maxPadding: numZero,
      crosshair: false,
      gridLineWidth: 1,
      gridZIndex: numTen,
      gridLineDashStyle: 'Dash',
      labels: {
        style: {
          color: whiteColor,
          fontFamily: 'Karla',
        },
        align: 'center',
        reserveSpace: false,
        rotation: numZero,
        formatter: function () {
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          const self: any = this
          return `<span class='text-base font-bold'>${
            categoryLabels
              ? categoryLabels[self.value]
              : defaultCategoryLabels[self.value]
          }</span>`
        },
      },
      lineWidth: numZero,
      margin: numZero,
      tickWidth: numZero,
      tickInterval: 1,
      startOnTick: true,
      endOnTick: true,
    },
    yAxis: {
      visible: false,
      startOnTick: false,
      endOnTick: false,
      // Default 5% padding on each side shrinks a 12px floor to about 11px.
      minPadding: numZero,
      maxPadding: numZero,
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      outside: true,
      backgroundColor: null,
      borderWidth: numZero,
      shadow: false,
      style: {
        color: whiteColor,
        fontFamily: 'Karla, sans-serif',
        fontWeight: 'bold',
        zIndex: 40,
      },
      useHTML: true,
      formatter: function () {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self: any = this
        if (setHoveredApp) {
          setHoveredApp({
            name: self?.point?.app as string,
            noOfUsers: self?.point?.noOfUsers,
            users: self?.point?.users,
          })
        }
        return `
        <div data-cy='stream-tooltip-${(
          self?.point?.app || ''
        ).toLowerCase()}-${
          self?.point?.index
        }' class='text-white shadowit-stream-chart-tooltip'>
          <div class='text-base font-bold'>${
            self?.point?.app || 'Loading...'
          }</div>
          <p class='text-xs font-normal'>
            <span>${
              formatBytes(self?.point?.dataConsumed ?? self?.point?.y) || ''
            }</span>
            <span class='text-gray-500'> | ${
              self?.point?.noOfUsers || numZero
            } Users</span>
          </p>
        </div>
        `
      },
    },
    plotOptions: {
      series: {
        cursor: 'pointer',
        lineColor: whiteColor,
        point: {
          events: {
            click: function () {
              streamClickHandler(this)
            },
          },
        },
      },
      streamgraph: {
        pointPlacement: 'between',
        allowPointSelect: true,
        stickyTracking: false,
        trackByArea: true,
        findNearestPointBy: 'xy',
        tooltip: {
          followPointer: true,
        },
      },
    },
    series: [
      {
        name: '',
        data: [
          {y: numZero},
          {y: numZero},
          {y: numZero},
          {y: numZero},
          {y: numZero},
          {y: numZero},
          {y: numZero},
        ],
      },
    ],
    exporting: {
      enabled: false,
    },
  }
}

// Update this array for different patterns to be show on stream graphs
export const streamGraphPatterns = [
  {
    // // blue bakcground  light pink pattern
    id: 'custom-pattern-0',
    path: {
      d: 'M-1,1 l2,-2 M0,45 l45,-45 M44,46 l2,-2',
      stroke: streamGraphColors[numZero],
      strokeWidth: numTwo,
    },
    width: numFortyFive,
    height: numFortyFive,
    backgroundColor: streamGraphColors[2],
    opacity: 1,
  },
  {
    // light pink pattern
    id: 'custom-pattern-1',
    color: streamGraphColors[numZero],
    opacity: 1,
  },
  {
    // dark pink pattern
    id: 'custom-pattern-2',
    color: streamGraphColors[1],
    opacity: 1,
  },
  {
    // .. light pink bakcground with blue dots
    id: 'custom-pattern-3',
    path: {
      d: 'M10 10 H 90 V 90 H 10 L 10 10 Z',
      stroke: streamGraphColors[numTwo],
      strokeWidth: 4,
    },
    width: numTen,
    height: numTen,
    backgroundColor: streamGraphColors[numZero],
    opacity: 1,
  },
  {
    // dark blue pattern
    id: 'custom-pattern-4',
    color: streamGraphColors[numTwo],
    opacity: 1,
  },
  {
    // // dark pink background with blue /
    id: 'custom-pattern-5',
    path: {
      d: 'M-1,1 l2,-2 M0,45 l45,-45 M44,46 l2,-2',
      stroke: streamGraphColors[numTwo],
      strokeWidth: numTwo,
    },
    width: numFortyFive,
    height: numFortyFive,
    backgroundColor: streamGraphColors[1],
    opacity: 1,
  },
  {
    // light pink pattern
    id: 'custom-pattern-6',
    color: streamGraphColors[numZero],
    opacity: 1,
  },
  {
    // .. dark blue bakcground with light pink dots
    id: 'custom-pattern-7',
    path: {
      d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
      strokeWidth: 1,
    },
    color: streamGraphColors[numZero],
    backgroundColor: streamGraphColors[1],
    width: numTen,
    height: numTen,
    opacity: 1,
  },
  {
    id: 'custom-pattern-8',
    path: {
      d: 'M0 0 L1,0 L1,1 L0,1 Z, M0 2 L3,0 L1,1 L0,3 Z,',
      stroke: whiteColor,
      strokeWidth: numTwo,
    },
    width: numTen,
    height: numTen,
    backgroundColor: streamGraphColors[numTwo],
    opacity: 1,
  },
  {
    id: 'custom-pattern-9',
    color: streamGraphColors[1],
    backgroundColor: streamGraphColors[numTwo],
    path: {
      d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
      strokeWidth: 3,
    },
    width: numTen,
    height: numTen,
    opacity: 1,
  },
  {
    id: 'custom-pattern-10',
    path: {
      d: 'M0 0 L2,3 L3 Z M6 0 L8,0',
      stroke: '#FFFFFF',
      strokeWidth: 1,
    },
    width: numTen,
    height: numTen,
    backgroundColor: streamGraphColors[1],
    opacity: 1,
  },

  {
    // // blue bakcground  light pink pattern
    id: 'custom-pattern-0',
    path: {
      d: 'M-1,1 l2,-2 M0,45 l45,-45 M44,46 l2,-2',
      stroke: streamGraphColors[numZero],
      strokeWidth: numTwo,
    },
    width: numFortyFive,
    height: numFortyFive,
    backgroundColor: streamGraphColors[numTwo],
    opacity: 1,
  },
  {
    // light pink pattern
    id: 'custom-pattern-1',
    color: streamGraphColors[numZero],
    opacity: 1,
  },
  {
    // dark pink pattern
    id: 'custom-pattern-2',
    color: streamGraphColors[1],
    opacity: 1,
  },
  {
    // .. light pink bakcground with blue dots
    id: 'custom-pattern-3',
    path: {
      d: 'M10 10 H 90 V 90 H 10 L 10 10 Z',
      stroke: streamGraphColors[numTwo],
      strokeWidth: 4,
    },
    width: numTen,
    height: numTen,
    backgroundColor: streamGraphColors[numZero],
    opacity: 1,
  },
  {
    // dark blue pattern
    id: 'custom-pattern-4',
    color: streamGraphColors[numTwo],
    opacity: 1,
  },
  {
    // // dark pink background with blue /
    id: 'custom-pattern-5',
    path: {
      d: 'M-1,1 l2,-2 M0,45 l45,-45 M44,46 l2,-2',
      stroke: streamGraphColors[numTwo],
      strokeWidth: numTwo,
    },
    width: numFortyFive,
    height: numFortyFive,
    backgroundColor: streamGraphColors[1],
    opacity: 1,
  },
  {
    // light pink pattern
    id: 'custom-pattern-6',
    color: streamGraphColors[numZero],
    opacity: 1,
  },
  {
    // .. dark blue bakcground with light pink dots
    id: 'custom-pattern-7',
    path: {
      d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
      strokeWidth: 1,
    },
    color: streamGraphColors[numZero],
    backgroundColor: streamGraphColors[1],
    width: numTen,
    height: numTen,
    opacity: 1,
  },
  {
    id: 'custom-pattern-8',
    path: {
      d: 'M0 0 L1,0 L1,1 L0,1 Z, M0 2 L3,0 L1,1 L0,3 Z,',
      stroke: whiteColor,
      strokeWidth: numTwo,
    },
    width: numTen,
    height: numTen,
    backgroundColor: streamGraphColors[numTwo],
    opacity: 1,
  },
  {
    id: 'custom-pattern-9',
    color: streamGraphColors[1],
    backgroundColor: streamGraphColors[numTwo],
    path: {
      d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
      strokeWidth: 3,
    },
    width: numTen,
    height: numTen,
    opacity: 1,
  },
  {
    id: 'custom-pattern-10',
    path: {
      d: 'M0 0 L2,3 L3 Z M6 0 L8,0',
      stroke: '#FFFFFF',
      strokeWidth: 1,
    },
    width: numTen,
    height: numTen,
    backgroundColor: streamGraphColors[1],
    opacity: 1,
  },
]

export const appRenameMap = {
  'Amazon Web Services (AWS)': 'AWS',
}

export const appRenameReverseMap = {
  AWS: 'Amazon Web Services (AWS)',
}
